import React, { useEffect, useMemo, useRef, useState } from "react";
import "./App.css";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import Settlement from "./pages/Settlement";
import Finance from "./pages/Finance/ClientFinance";
import { useDispatch, useSelector } from "react-redux";
import { login } from "./redux/authSlice";
import Layout from "./components/ui/Layout";
import Orders from "./pages/Order";
import MyAccount from "./pages/Account/MyAccount";
import RegisteredOrders from "./pages/Order/RegisteredOrders";
import WaitingPickupOrders from "./pages/Order/WaitingPickupOrders";
import OrderDetails from "./pages/Order/OrderDetails";
import Client from "./pages/Client";
import Driver from "./pages/Driver";
import BlackListAccounts from "./pages/BlacklistAccounts";
import BlockedAccounts from "./pages/BlockedAccounts";
import ClientDetails from "./pages/Client/ClientDetails";
import DriverDetails from "./pages/Driver/DriverDetails";
import { ToastContainer } from "react-toastify";
import Arrangments from "./pages/Arrangments/index";
import Footer from "./components/Footer";
import SettlementRefusal from "./pages/Settlement/SettlementRefusal";
import UnapprovedAccounts from "./pages/UnapprovedAccounts";
import RegisterForm from "./pages/Login/RegisterForm";
import RegisterBuyerForm from "./pages/Buyer/RegisterBuyerForm";
import UnlinkedBuyers from "./pages/Buyer/UnlinkedBuyers";
import Register from "./pages/Order/Register";
import AuthorizedRoute from "./components/AuthorizedRoute";
import BulkOperationsRoute from "./components/BulkOperationsRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import Messages from "./pages/Communications/Messages";
import Notification from "./pages/Communications/Notification";
import ReturnOrders from "./pages/Order/ReturnOrder";
import RedirectedOrders from "./pages/Order/ReturnOrder/RedirectedOrders";
import StaffAcount from "./pages/StaffAccounts";
import MainPage from "./pages/MainPage/MainPage";
import ForUs from "./pages/MainPage/ForUs/ForUs";
import MainPageNotifications from "./pages/MainPage/ForUs/MainPageNotifications";
import TermsOfService from "./pages/MainPage/ForUs/TermsOfService";
import Faq from "./pages/MainPage/ForUs/Faq";
import Pricelist from "./pages/MainPage/Pricelist";
import Contact from "./pages/MainPage/Contact";
import MobileApp from "./pages/MainPage/MobileApp";
import MainPageFooter from "./components/MainPageFooter";
import LoadingScreen from "./components/LoadingScreen";
import MainPageHeader from "./components/MainPageHeader";
import {
	getUserIdFromToken,
	getUserMenuOptionsFromToken,
	getUserRoleFromToken,
} from "./utils/Auth";
import { createHubConnection } from "./utils/hubConnection";
import isAuthenticated from "./utils/isAuthenticated";
import UserDocumentsRestore from "./pages/UserDocumentsRestore";
import PasswordResetForm from "./pages/PasswordResetForm";
import PasswordRecoveryForm from "./pages/PasswordRecoveryForm";
import NoAccessPage from "./pages/NoAccessPage";
import MessageModal from "./components/messageModal/MessageModal";
import { showMessageModal } from "./redux/messageModalSlice";
import AdminFinanceTabs from "./pages/Finance/AdminFinanceTabs";
import { setReceivedNewMessages } from "./redux/messageNotificationSlice";
import ChatApp from "./pages/ChatApp/ChatApp";
import OurPartners from "./pages/MainPage/ForUs/OurPartners";
import NewsDetails from "./pages/MainPage/ForUs/NewsDetails";
import SubClientAccounts from "./pages/SubClientAccounts";
import Refunds from "./pages/Refunds";
import { setReceivedNewNotification } from "./redux/notificationSlice";
import { userRoles } from "./types/enums";
import MinimalHeader from "./components/MinimalHeader";
import { IsOldNewClient } from "./utils/IsOldNewClient";
import VideoTutorial from "./pages/VideoTutorial";
import MockOrders from "./pages/Order/MockOrder/MockOrders";
import PickupPoints from "./pages/PickupPoints";
import BulkOrderOperations from "./pages/BulkOrderOperations";
import BulkOperationsCategory from "./pages/BulkOrderOperations/CategoryRouter";
import ClientReportsReport from "./pages/BulkOrderOperations/client-reports/ReportRouter";
import OrderTracking from "./pages/OrderTracking";
import OrderTrackingRedirect from "./pages/OrderTracking/OrderTrackingRedirect";

const App = () => {
	const loggedIn = isAuthenticated();
	const token = useSelector((state: any) => state.auth.token);
	const requiresDocumentation = IsOldNewClient();
	const [checkingToken, setCheckingToken] = useState<boolean>(true);

	const isSkanoModalOpen = useSelector(
		(state: any) => state.skanoModal?.isOpen
	);
	const isSkanoModalOpenRef = useRef(isSkanoModalOpen);
	isSkanoModalOpenRef.current = isSkanoModalOpen;

	// const [receivedNewMesages, setReceivedNewMessages] =
	// 	useState<boolean>(false);
	const dispatch = useDispatch();

	const location = useLocation();
	const refreshKey = (location.state as { refreshAt?: number } | null)
		?.refreshAt;
	const userRoleId = useMemo(() => getUserRoleFromToken(), [token]);
	const menuOptions = useMemo(() => getUserMenuOptionsFromToken(), [token]);
	const hasOldMessagesAccess = useMemo(
		() => menuOptions?.includes("MESSAGES_ACCESS_OLD_ACCESS"),
		[menuOptions]
	);

	useEffect(() => {
		isSkanoModalOpenRef.current = isSkanoModalOpen;
	}, [isSkanoModalOpen]);

	useEffect(() => {
		if (location?.pathname === "/messages") {
			dispatch(setReceivedNewMessages(false));
		}
	}, [location, setReceivedNewMessages]);

	const isLoggedIn = !!token;

	console.log(isSkanoModalOpenRef, "isSkanoModalOpenRef");

	/*
	 * One pair of hub connections per login. This used to depend on `token`, which the session
	 * refresher replaces about every 5 minutes: each refresh stopped both hubs, tried to restart
	 * the same connection objects while they were still disconnecting, and made the server rerun
	 * the pending-notification queries. `accessTokenFactory` reads the current token from
	 * localStorage, so automatic reconnects already use the refreshed one.
	 */
	useEffect(() => {
		if (!isLoggedIn) return;

		const userId = getUserIdFromToken();
		const messageHub = createHubConnection("user/message");
		const notificationHub = createHubConnection("user/notification");

		messageHub.on(
			"ReceiveMessage",
			(title: string, message: string, senderUserId: any) => {
				dispatch(setReceivedNewMessages(true));
				if (!isSkanoModalOpenRef.current) {
					dispatch(
						showMessageModal({
							title,
							message,
							userId: senderUserId,
						})
					);
				}
				console.log("Received message from message hub");
			}
		);
		notificationHub.on(
			"ReceiveNotification",
			(title: string, message: string) => {
				dispatch(setReceivedNewNotification(true));
				console.log(
					"Received notification from notification hub",
					title,
					message
				);
			}
		);

		// The server drops group membership with the old connection, so join again after an
		// automatic reconnect as well as after the first start.
		const joinMessages = () =>
			messageHub
				.invoke("JoinUserMessage", userId)
				.catch((e: any) => console.error("Message hub join error", e));
		const joinNotifications = () =>
			notificationHub
				.invoke("JoinUserNotification", userId)
				.catch((e: any) =>
					console.error("Notification hub join error", e)
				);
		messageHub.onreconnected(() => joinMessages());
		notificationHub.onreconnected(() => joinNotifications());

		console.log("Connecting to hubs...");
		messageHub
			.start()
			.then(() => joinMessages())
			.catch((e: any) => {
				console.error("Message hub connection error", e);
			});
		notificationHub
			.start()
			.then(() => joinNotifications())
			.catch((e: any) => {
				console.error("Notification hub connection error", e);
			});

		return () => {
			messageHub.stop().catch((err) => console.error(err));
			notificationHub.stop().catch((err) => console.error(err));
		};
	}, [isLoggedIn, dispatch]);

	useEffect(() => {
		try {
			if (token) {
				setCheckingToken(false);
				return;
			}
			const dispatchUserAccessIfLoggedIn = async () => {
				const authToken = localStorage.getItem("token");
				if (!authToken) {
					setCheckingToken(false);
					return;
				}
				dispatch(login({ token: authToken }));
				setCheckingToken(false);
			};
			dispatchUserAccessIfLoggedIn();
		} catch (error) {
			console.error("App Error", error);
		}
	}, [dispatch, token]);

	if (!token && checkingToken) {
		return <></>;
	}
	const showHeaderForNews = location.state?.title ? true : false;

	const noHeaderFooterPaths = [
		"/main",
		"/for-us",
		"/mainpage-notifications",
		"/staff",
		"/tos",
		"/faq",
		"/pricelist",
		"/contact",
		"/mobileapp",
		"/partners",
		"/order-tracking",
	];
	const showHeaderFooter = noHeaderFooterPaths.includes(location.pathname);
	const isClientRole = userRoleId === userRoles.CLIENT;
	const messagesComponent =
		!isClientRole && hasOldMessagesAccess ? <Messages /> : <ChatApp />;
	return (
		<>
			<LoadingScreen />
			<MessageModal />
			{loggedIn && requiresDocumentation ? (
				<MinimalHeader />
			) : showHeaderFooter || showHeaderForNews ? (
				<MainPageHeader />
			) : (
				<Header loggedIn={loggedIn} />
			)}
			<ToastContainer
				position="top-right"
				autoClose={5000}
				closeOnClick
				pauseOnHover
			/>
			<Layout>
				{/* Clicking the open page's menu item sets `refreshAt` (Header `goTo`): the new key remounts
				    that page so it reloads its data, without reloading the app. */}
				<Routes key={refreshKey}>
					<Route path="/" element={<Navigate to="/dashboard" />} />
					<Route
						path="/dashboard"
						element={
							<AuthorizedRoute
								menuAccesses="HOME_ACCESS"
								component={<Dashboard />}
							/>
						}
					/>
					<Route
						path="/order"
						element={
							<AuthorizedRoute
								menuAccesses="ORDERS_ACCESS"
								component={<Orders />}
							/>
						}
					/>
					<Route
						path="/dashboard-orders"
						element={
							<AuthorizedRoute
								menuAccesses="MOCK_ORDERS_ACCESS"
								component={<MockOrders />}
							/>
						}
					/>

					<Route
						path="/register-order"
						element={
							<AuthorizedRoute
								menuAccesses="REGISTER_ORDER_ACCESS"
								component={<Register />}
							/>
						}
					/>
					<Route
						path="/registered-orders"
						element={
							<AuthorizedRoute
								menuAccesses="REGISTERED_ORDERS_ACCESS"
								component={<RegisteredOrders />}
							/>
						}
					/>
					<Route
						path="/waiting-pickup-orders"
						element={
							<AuthorizedRoute
								menuAccesses="WAITING_PICKUP_ORDERS_ACCESS"
								component={<WaitingPickupOrders />}
							/>
						}
					/>
					<Route
						path="/return-storage-orders"
						element={
							<AuthorizedRoute
								menuAccesses="RETURN_STORAGE_ORDERS_ACCESS"
								component={<ReturnOrders />}
							/>
						}
					/>
					<Route
						path="/redirected-orders"
						element={
							<AuthorizedRoute
								menuAccesses="REDIRECTED_ORDERS_ACCESS"
								component={<RedirectedOrders />}
							/>
						}
					/>
					<Route
						path="/subclient-accounts"
						element={
							<AuthorizedRoute
								menuAccesses="SUBCLIENT_ACCOUNTS_ACCESS"
								component={<SubClientAccounts />}
							/>
						}
					/>
					<Route
						path="/pickup-points"
						element={
							<AuthorizedRoute
								menuAccesses="PICKUP_POINTS_ACCESS"
								component={<PickupPoints />}
							/>
						}
					/>
					<Route
						path="/finance"
						element={
							<AuthorizedRoute
								menuAccesses="FINANCES_ACCESS"
								component={<Finance />}
							/>
						}
					/>
					{/* <Route path="/staff" element={<Staff />} /> */}
					<Route path="/tos" element={<TermsOfService />} />
					<Route path="/faq" element={<Faq />} />
					<Route path="/pricelist" element={<Pricelist />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/mobileapp" element={<MobileApp />} />
					<Route
						path="/:title"
						element={
							<>
								<NewsDetails />
							</>
						}
					/>

					{/* <Route path="/signup" element={<SignUp />} /> */}

					<Route
						path="/order-details"
						element={
							<AuthorizedRoute
								menuAccesses={[
									"ORDERS_ACCESS",
									"REDIRECTED_ORDERS_ACCESS",
									"RETURN_STORAGE_ORDERS_ACCESS",
									"REGISTER_ORDER_ACCESS",
									"WAITING_PICKUP_ORDERS_ACCESS",
								]}
								component={<OrderDetails />}
							/>
						}
					/>

					<Route
						path="/admin-finance"
						element={
							<AuthorizedRoute
								menuAccesses="ADMIN_FINANCES_ACCESS"
								component={<AdminFinanceTabs />}
							/>
						}
					/>
					<Route
						path="/settlement"
						element={
							<AuthorizedRoute
								menuAccesses="SETTLEMENTS_ACCESS"
								component={<Settlement />}
							/>
						}
					/>
					<Route
						path="/refusals"
						element={
							<AuthorizedRoute
								menuAccesses="REFUSALS_ACCESS"
								component={<SettlementRefusal />}
							/>
						}
					/>
					<Route
						path="/clients"
						element={
							<AuthorizedRoute
								menuAccesses="CLIENTS_ACCESS"
								component={<Client />}
							/>
						}
					/>
					<Route
						path="/client-details"
						element={
							<AuthorizedRoute
								menuAccesses={[
									"CLIENTS_ACCESS",
									"CLIENT_DETAILS_ACCESS",
								]}
								component={<ClientDetails />}
							/>
						}
					/>
					<Route
						path="/drivers"
						element={
							<AuthorizedRoute
								menuAccesses="DRIVERS_ACCESS"
								component={<Driver />}
							/>
						}
					/>
					<Route
						path="/driver-details"
						element={
							<AuthorizedRoute
								menuAccesses={[
									"DRIVERS_ACCESS",
									"DRIVER_DETAILS_ACCESS",
								]}
								component={<DriverDetails />}
							/>
						}
					/>
					<Route
						path="/staff-accounts"
						element={
							<AuthorizedRoute
								menuAccesses={"STAFF_ACCOUNTS_ACCESS"}
								component={<StaffAcount />}
							/>
						}
					/>

					<Route
						path="/blocked-accounts"
						element={
							<AuthorizedRoute
								menuAccesses="BLOCKED_ACCOUNTS_ACCESS"
								component={<BlockedAccounts />}
							/>
						}
					/>
					<Route
						path="/passive-client-accounts"
						element={
							<AuthorizedRoute
								menuAccesses="PASSIVE_CLIENT_ACCOUNTS_ACCESS"
								component={<BlackListAccounts />}
							/>
						}
					/>
					<Route
						path="/unapproved-accounts"
						element={
							<AuthorizedRoute
								menuAccesses="UNAPPROVED_ACCOUNTS_ACCESS"
								component={<UnapprovedAccounts />}
							/>
						}
					/>

					<Route
						path="/unlinked-buyer"
						element={
							<AuthorizedRoute
								menuAccesses="UNLINKED_BUYERS_ACCESS"
								component={<UnlinkedBuyers />}
							/>
						}
					/>
					<Route
						path="/refunds"
						element={
							<AuthorizedRoute
								menuAccesses="REFUNDS_ACCESS"
								component={<Refunds />}
							/>
						}
					/>
					<Route
						path="/my-account"
						element={
							<AuthorizedRoute
								menuAccesses="PROFILE_ACCESS"
								component={<MyAccount />}
							/>
						}
						// <ProtectedRoute component={<MyAccount />} />}
					/>
					<Route
						path="/messages"
						element={
							<AuthorizedRoute
								menuAccesses={[
									"MESSAGES_ACCESS",
									"MESSAGES_ACCESS_OLD_ACCESS",
								]}
								component={messagesComponent}
							/>
						}
					/>
					<Route
						path="/notification"
						element={
							<ProtectedRoute component={<Notification />} />
						}
					/>
					<Route
						path="/no-access"
						element={
							<ProtectedRoute component={<NoAccessPage />} />
						}
					/>
					<Route
						path="/arrangments"
						element={
							<AuthorizedRoute
								menuAccesses="ARRANGEMENTS_ACCESS"
								component={<Arrangments />}
							/>
						}
					/>
					<Route
						path="/bulk-order-operations"
						element={
							<BulkOperationsRoute
								component={<BulkOrderOperations />}
							/>
						}
					/>
					<Route
						path="/bulk-order-operations/:category"
						element={
							<BulkOperationsRoute
								component={<BulkOperationsCategory />}
							/>
						}
					/>
					<Route
						path="/bulk-order-operations/client-reports/:report"
						element={
							<BulkOperationsRoute
								component={<ClientReportsReport />}
							/>
						}
					/>
					<Route
						path="/user-document-restore"
						element={
							<ProtectedRoute
								component={<UserDocumentsRestore />}
							/>
						}
					/>
					<Route path="/login" element={<Login />} />
					<Route path="/register" element={<RegisterForm />} />
					<Route
						path="/temporary-register-link/:uuid"
						element={<RegisterBuyerForm />}
					/>
					<Route
						path="/password-recovery"
						element={<PasswordRecoveryForm />}
					/>
					<Route
						path="/password-reset/:uuid"
						element={<PasswordResetForm />}
					/>
					<Route path="/main" element={<MainPage />} />
					<Route path="/order-tracking" element={<OrderTracking />} />
					<Route path="/usage-manuals" element={<VideoTutorial />} />
					<Route path="/for-us" element={<ForUs />} />
					<Route
						path="/mainpage-notifications"
						element={<MainPageNotifications />}
					/>
					<Route path="/tos" element={<TermsOfService />} />
					<Route path="/faq" element={<Faq />} />
					<Route path="/pricelist" element={<Pricelist />} />
					<Route path="/partners" element={<OurPartners />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/mobileapp" element={<MobileApp />} />
					<Route path="/:id/t" element={<OrderTrackingRedirect />} />

					<Route path="/" element={<Navigate to="/main" />} />
				</Routes>
			</Layout>
			{showHeaderFooter || showHeaderForNews ? (
				<MainPageFooter />
			) : (
				<Footer />
			)}
		</>
	);
};

export default App;
